export const KICKSTARTER_URL =
  'https://www.kickstarter.com/projects/charlottedann/hexatope-design-your-own-unique-jewellery';
export const TWITTER_URL = 'https://twitter.com/hexatope';
export const INSTAGRAM_URL = 'https://www.instagram.com/hexatope';
export const FACEBOOK_URL = 'https://www.facebook.com/hexatope';
